import { getBackendClient, unwrapApiResponse } from '~/api/client'
import {
  clearHelpCenterIdentity,
  setHelpCenterIdentity,
} from '~/services/helpCenter'

let syncedDistinctId: string | null = null

export const syncHelpCenterIdentity = async (): Promise<void> => {
  const runtimeConfig = useRuntimeConfig()
  if (runtimeConfig.public.helpCenterEnabled !== true) return

  try {
    const client = getBackendClient({ impersonation: false })
    const identity = await unwrapApiResponse(client.GET('/support/identity'))

    if (identity.distinct_id === syncedDistinctId) return

    setHelpCenterIdentity(identity.distinct_id, identity.identity_hash)
    syncedDistinctId = identity.distinct_id
  }
  catch (error) {
    $log('PostHog Support identity verification is unavailable', error)
  }
}

export const resetHelpCenterIdentity = () => {
  syncedDistinctId = null
  clearHelpCenterIdentity()
}
